<template>
    <div name="challenge" class="challenge" v-if="result === 0">
        <!-- 챔피언스시티: 내 건강 / 솔닥 챌린지 / 건강상담 AI 챗봇 3탭 -->
        <div v-if="isChampionscity" class="tab-wrapper">
            <img class="image" :src="ccTabImage" />
            <div class="cc-tab" style="left: 0; width: 22.4%;" @click="tabChange(0)"></div>
            <div class="cc-tab" style="left: 22.4%; width: 29.6%;" @click="tabChange(1)"></div>
            <div class="cc-tab" style="left: 52%; width: 48%;" @click="tabChange(2)"></div>
        </div>
        <template v-else>
            <img v-if="tab === 0" class="image" src="../../assets/showcase/xi/challenge/tab1.png" />
            <div class="tab-button1" @click="tabButton1">

            </div>
            <img v-if="tab === 1" @click="tabButton2" class="image" src="../../assets/showcase/xi/challenge/tab2.png" />
            <div class="tab-button2" @click="tabButton2">

            </div>
        </template>
        <!-- 챔피언스시티 건강상담 AI 챗봇 대화 -->
        <div v-if="isChampionscity && tab === 2" class="challenge" style="margin-bottom: calc(100vw * 120 / 375);">
            <img class="image" src="../../assets/showcase/championscity/challenge/chat1.png" />
            <img class="image" src="../../assets/showcase/championscity/challenge/chat2.png" @click="goBooking" />
            <img class="image" src="../../assets/showcase/championscity/challenge/chat3.png" />
        </div>
        <!-- 챔피언스시티 내 건강: 체성분 / 자세·관절 / 체력 서브탭 -->
        <div v-else-if="isChampionscity && tab === 0" class="challenge" style="margin-bottom: calc(100vw * 120 / 375);">
            <div class="tab-wrapper">
                <img class="image" :src="ccHealthTabImage" />
                <div class="cc-tab" style="left: 0; width: 27.9%;" @click="healthTabChange(0)"></div>
                <div class="cc-tab" style="left: 27.9%; width: 31.8%;" @click="healthTabChange(1)"></div>
                <div class="cc-tab" style="left: 59.7%; width: 25.3%;" @click="healthTabChange(2)"></div>
            </div>
            <img class="image" :src="ccHealthImage" />
            <img
                class="cc-ai-floating"
                src="../../assets/showcase/championscity/challenge/ai_floating.png"
                @click="goAiChat"
            />
        </div>
        <div  v-else-if="tab == 0" style="margin-bottom: calc(100vw * 120 / 375); width: 100%; position: relative; ">   
            <img class="image" src="../../assets/showcase/xi/challenge/challenge1.png" />
        </div>
        <div v-else class="challenge">
            <img class="image" src="../../assets/showcase/xi/challenge/1.png" />
            <img class="image" src="../../assets/showcase/xi/challenge/3.png" />
            <img class="image" @click="useLottery" src="../../assets/showcase/xi/challenge/4.png" />
            <img class="image" src="../../assets/showcase/xi/challenge/2_1.png" />
            <img class="image" src="../../assets/showcase/xi/challenge/2.png" @click="resultChange(3)"/>

            <img class="image" src="../../assets/showcase/xi/challenge/5.png" @click="resultChange(4)"/>
            <img class="image" src="../../assets/showcase/xi/challenge/6.png" />
            <img class="image" src="../../assets/showcase/xi/challenge/7.png" />
        </div>
    </div>
    <div v-else-if="result === 1" class="challenge">
        <img class="image" src="../../assets/showcase/xi/challenge/result1.png" @click="back" />
        <img class="image" src="../../assets/showcase/xi/challenge/result2.png" @click="resultChange(2)"/>
        <img class="image" src="../../assets/showcase/xi/challenge/result3.png" />
        <!-- <img class="image"  style="position: fixed; bottom: 8vh; width: 100%;" src="../../assets/showcase/xi/challenge/result4.png" /> -->
    </div>
     <div v-else-if="result === 2" class="challenge">
        <img class="image" src="../../assets/showcase/xi/challenge/r1.png" @click="back" />
        <img class="image" src="../../assets/showcase/xi/challenge/r2.png" />
        <img class="image" src="../../assets/showcase/xi/challenge/r3.png" />
        <!-- <img class="image"  style="position: fixed; bottom: 8vh; width: 100%;" src="../../assets/showcase/xi/challenge/result4.png" /> -->
    </div>
    <div v-else-if="result === 3" class="challenge">
        <img class="image" src="../../assets/showcase/xi/challenge/l1.png" @click="back" />
        <img class="image" src="../../assets/showcase/xi/challenge/l2.png" />
    </div>
    <div v-else-if="result === 4" class="challenge">
        <img class="image" src="../../assets/showcase/xi/challenge/ll1.png" @click="back" />
        <img class="image" src="../../assets/showcase/xi/challenge/ll2.png" @click="resultChange(5)"/>
        <img class="image" src="../../assets/showcase/xi/challenge/ll3.png" />
    </div>
    <div v-else-if="result === 5" class="challenge">
        <img class="image" src="../../assets/showcase/xi/challenge/w1.png" @click="back" />
        <img class="image" src="../../assets/showcase/xi/challenge/w2.png" @click="resultChange(4)"/>
        <img class="image" src="../../assets/showcase/xi/challenge/w3.png" />
    </div>
</template>

<script>
export default {
    name: 'challenge',
    data: function()
    {
        return {
            tab: 0,
            healthTab: 0,
            result: 0,
            ccTabImages: [
                require('../../assets/showcase/championscity/challenge/tab1.png'),
                require('../../assets/showcase/championscity/challenge/tab2.png'),
                require('../../assets/showcase/championscity/challenge/tab3.png')
            ],
            ccHealthTabImages: [
                require('../../assets/showcase/championscity/challenge/health_tab1.png'),
                require('../../assets/showcase/championscity/challenge/health_tab2.png'),
                require('../../assets/showcase/championscity/challenge/health_tab3.png')
            ],
            ccHealthImages: [
                require('../../assets/showcase/championscity/challenge/health1.png'),
                require('../../assets/showcase/championscity/challenge/health2.png'),
                require('../../assets/showcase/championscity/challenge/health3.png')
            ]
        }
    },
    computed: {
        isChampionscity: function()
        {
            return this.$route.params.showcase === 'championscity'
        },
        ccTabImage: function()
        {
            return this.ccTabImages[this.tab] || this.ccTabImages[0]
        },
        ccHealthTabImage: function()
        {
            return this.ccHealthTabImages[this.healthTab] || this.ccHealthTabImages[0]
        },
        ccHealthImage: function()
        {
            return this.ccHealthImages[this.healthTab] || this.ccHealthImages[0]
        }
    },
    methods: {
        tabChange: function(tab)
        {
            this.tab = tab;
            this.healthTab = 0;
            this.reset();
        },
        healthTabChange: function(healthTab)
        {
            this.healthTab = healthTab;
            this.reset();
        },
        goAiChat: function()
        {
            this.tabChange(2);
        },
        tabButton1: function()
        {
            this.tab = 1;
            this.reset();
        },
        tabButton2: function()
        {
            this.tab = 0;
            this.reset();
        },
        useLottery: function()
        {
            this.result = 1;
            this.reset();
        },
        back: function()
        {
            this.result = 0
            this.reset();
        },
        resultChange: function(result)
        {
            this.result = result;
            this.reset();
        },
        reset: function()
        {
            this.$emit('resetCount')
        },
        goBooking: function()
        {
            this.$emit('goBooking')
        }
    }
}
</script>

<style scoped>
    .challenge {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .image {
        width: 100%;
    }
    .tab-wrapper {
        width: 100%;
        position: relative;
        line-height: 0;
    }
    .cc-tab {
        position: absolute;
        top: 0;
        bottom: 0;
        cursor: pointer;
    }
    .cc-ai-floating {
        position: fixed;
        right: 4vw;
        /* 푸터 버튼바(100vw*60/375) + 네비게이션((100vw-8.6vw)*60/375) 위로 */
        bottom: calc(100vw * 60 / 375 + 91.4vw * 60 / 375 + 2vw);
        width: 67vw;
        z-index: 998;
        cursor: pointer;
    }
    .tab-button1 {
        width: 24vw;
        height: 12vw;
        position: absolute;
        top: 0;
        left: 22vw;
    }
    .tab-button2 {
        width: 17vw;
        height: 12vw;
        position: absolute;
        top: 0;
        left: 2vw;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/Challenge.vue